import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";
import IconButton from "components/common/IconButton";
import { ButtonToolbar } from "components/bootstrap";
import { CELL_PADDING_HORIZONTAL, CELL_PADDING_VERTICAL } from "components/common/EntityDataTable/Constants";
import { scrollContainerWidthVar } from "components/common/EntityDataTable/CSSVariables";
import ExpandedEntitiesSectionsContext from "./contexts/ExpandedSectionsContext";
const Container = styled.tr(
  ({ theme }) => css`
    &&&& {
      background-color: ${theme.colors.global.contentBackground};
    }
  `
);
const ContentCell = styled.td`
  && {
    padding: 0;
    border-top-color: ${({ theme }) => theme.colors.table.row.backgroundStriped} !important;
  }
`;
const Content = styled.div(
  ({ theme }) => css`
    position: sticky;
    left: 0;
    width: 100%;
    max-width: var(${scrollContainerWidthVar}, 100%);
    padding: ${CELL_PADDING_VERTICAL}px ${CELL_PADDING_HORIZONTAL}px ${theme.spacings.md} ${theme.spacings.lg};
    background-color: ${theme.colors.table.row.backgroundStriped};
  `
);
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${theme.spacings.sm};
  `
);
const Actions = styled(ButtonToolbar)`
  display: flex;
  align-items: center;
`;
const HideSectionButton = styled(IconButton)`
  margin-left: 5px;
`;
const ExpandedSections = ({
  expandedSectionRenderers,
  entity,
  visibleCellCount
}) => {
  const { expandedSections, toggleSection } = useContext(ExpandedEntitiesSectionsContext);
  const expandedEntitySections = expandedSections == null ? void 0 : expandedSections[entity.id];
  if (!(expandedEntitySections == null ? void 0 : expandedEntitySections.length)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ContentCell, { colSpan: visibleCellCount }, /* @__PURE__ */ React.createElement(Content, null, Object.entries(expandedSectionRenderers != null ? expandedSectionRenderers : {}).filter(([sectionName]) => expandedEntitySections.includes(sectionName)).map(([sectionName, section]) => {
    var _a;
    const hideSection = () => toggleSection(entity.id, sectionName);
    const actions = (_a = section.actions) == null ? void 0 : _a.call(section, entity);
    return /* @__PURE__ */ React.createElement("div", { key: `${sectionName}-${entity.id}` }, section.disableHeader !== true ? /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("h3", null, section.title), /* @__PURE__ */ React.createElement(Actions, null, actions, /* @__PURE__ */ React.createElement(HideSectionButton, { name: "keyboard_arrow_up", onClick: hideSection, title: "Collapse section" }))) : null, section.content(entity));
  }))));
};
export default ExpandedSections;
